// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"u4-z","dimensionLabel":"v4-z","styleChooserControlWrapper":"w4-z","styleChooserControl":"x4-z","disabled":"y4-z","giftCard":"z4-z","styleChooserText":"A4-z"};